import accordionSummaryClasses from "@mui/material/AccordionSummary/accordionSummaryClasses";
import accordionClasses from "@mui/material/Accordion/accordionClasses";
import { transition } from "../../styles/utils/utils";
const borderWidth = "1px";
export const MuiAccordionTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                border: `${borderWidth} solid ${dt.color.outlineVariant}`,
                backgroundColor: dt.color.surface.key,
                boxShadow: "none",
                "&::before": {
                    display: "none",
                },
                [`& + .${accordionClasses.root}`]: {
                    borderTopWidth: 0,
                },
                [`.${accordionSummaryClasses.root}`]: {
                    minHeight: "auto",
                    padding: `${dt.stacked.medium} ${dt.inline.medium}`,
                    "&.Mui-expanded": {
                        minHeight: "auto",
                    },
                    "&::after": {
                        pointerEvents: "none",
                        content: "''",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        transition: transition(["background-color", "margin", "border-radius"]),
                    },
                    "&:is(:hover, :focus-visible, :is(.Pxl-demo-hover, [data-demostate=hover]))::after": {
                        transition: transition(['background-color', 'margin', 'border-radius'], 'hover'),
                        backgroundColor: dt.cta.outlined.color.background.neutral.hover,
                    },
                },
                [`&.${accordionClasses.expanded}`]: {
                    marginTop: 0,
                    marginBottom: 0,
                },
                [`&.${accordionClasses.disabled}`]: {
                    background: "transparent",
                    [`.${accordionSummaryClasses.root}`]: {
                        pointerEvents: "none",
                        opacity: dt.opacity.states.disabled.content,
                    },
                },
                "&:first-of-type": {
                    borderTopLeftRadius: dt.brand.borderRadius.medium,
                    borderTopRightRadius: dt.brand.borderRadius.medium,
                    [`.${accordionSummaryClasses.root}, .${accordionSummaryClasses.root}::after`]: {
                        borderTopLeftRadius: `calc(${dt.brand.borderRadius.medium} - ${borderWidth})`,
                        borderTopRightRadius: `calc(${dt.brand.borderRadius.medium} - ${borderWidth})`,
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    },
                },
                "&:last-of-type": {
                    borderBottomLeftRadius: dt.brand.borderRadius.medium,
                    borderBottomRightRadius: dt.brand.borderRadius.medium,
                    [`.${accordionSummaryClasses.root}, .${accordionSummaryClasses.root}::after`]: {
                        borderBottomLeftRadius: `calc(${dt.brand.borderRadius.medium} - ${borderWidth})`,
                        borderBottomRightRadius: `calc(${dt.brand.borderRadius.medium} - ${borderWidth})`,
                    },
                    [`.${accordionSummaryClasses.root}.Mui-expanded, .${accordionSummaryClasses.root}.Mui-expanded::after`]: {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    },
                    "&:not(:first-of-type)": {
                        [`.${accordionSummaryClasses.root}, .${accordionSummaryClasses.root}::after`]: {
                            borderTopLeftRadius: 0,
                            borderTopRightRadius: 0,
                        },
                    },
                },
            },
        },
    };
};
